import type { ITripTalon } from '~~/shared/interfaces/tripCustomsPhoto';

export const useTripCustomsPhotoStore = defineStore('tripCustomsPhoto', () => {
	const abortControllers: Record<string, AbortController> = {};

	const abortRequest = (key: string) => {
		if (abortControllers[key]) {
			abortControllers[key].abort();
		}
		abortControllers[key] = new AbortController();
		return abortControllers[key].signal;
	};

	const loading = reactive({});

	function $reset() {}

	const getByTrip = async (paylad: { tripId: string }) => {
		const signal = abortRequest('getTripsOnTheWay');
		const { data, status } = await useCustomFetch<ITripTalon[]>(
			'/api/TripCustomsPhoto/get-by-trip',
			{
				query: paylad,
				signal,
				timeout: 4000,
				watch: false
			},
			{ isSilent: false }
		);

		if (status.value === 'success' && data.value) {
		}

		return { data: data.value, status: status.value };
	};

	const tripCustomPhotoUpload = async (payload: { tripId: string; files: { blobUrl: string; file: File }[] }) => {
		const signal = abortRequest('tripCustomPhotoUpload');
		const formData = new FormData();

		formData.append('tripId', payload.tripId);
		payload.files.forEach((f) => {
			formData.append('files', f.file);
		});

		const { data, status } = await useCustomFetch<any>(
			'/api/TripCustomsPhoto/upload',
			{
				body: formData,
				method: 'post',
				signal,
				timeout: 4000,
				watch: false
			},
			{ isSilent: false }
		);

		if (status.value === 'success' && data.value) {
		}

		return { data: data.value, status: status.value };
	};

	const tripCustomPhotoDelete = async (payload: { id: string }) => {
		const signal = abortRequest('tripCustomPhotoDelete');

		const { data, status } = await useCustomFetch<any>(
			'/api/TripCustomsPhoto/delete',
			{
				query: payload,
				method: 'delete',
				signal,
				timeout: 4000,
				watch: false
			},
			{ isSilent: false }
		);

		if (status.value === 'success' && data.value) {
		}

		return { data: data.value, status: status.value };
	};

	return {
		loading,
		$reset,
		getByTrip,
		tripCustomPhotoUpload,
		tripCustomPhotoDelete
	};
});
